import axios from 'axios';

import { CharityRegisterInterfaces } from '@/interfaces/charity-register';

const baseURL = process.env.VUE_APP_API_URL + '/charity';

class CharityRegisterService {
    // Looked up before any other field on step 1; branch on result.match_type.
    static checkEmail(email: string) {
        const url = `${baseURL}/register/check-email`;

        return axios.post<CharityRegisterInterfaces.ICheckEmailResponse>(url, { email });
    }
    static createCharity(data:any) {
        const url = `${baseURL}/request/submit`;

        return axios.post(url,data);
    }
    static step1(data:any) {
        const url = `${baseURL}/register/step-1/manager-info`;

        return axios.post(url,data);
    }

    static step2(id:any) {
        const url = `${baseURL}/register/step-2/${id}`;

        return axios.get(url);
    }

    // Adding data in step 2 
    static step2Add(id:any,data:any) {
        const url = `${baseURL}/register/step-2/${id}`;
        return axios.patch(url,data);
    }


    static step3(data:any) {
        const url = `${baseURL}/register/step-3`;

        return axios.post(url,data);
    }

    static step3Add(id:number, data:any) {
        const url = `${baseURL}/register/step-3/${id}`;
        return axios.patch(url,data);
    }


    static step4(id:any,data:any) {
        const url = `${baseURL}/register/step-4/${id}`;

        return axios.patch(url,data);
    }
    static getCharityDetails(id:any) {
        const url = `${baseURL}/charity-details/${id}`;

        return axios.get(url);
    }
    static getIBANfromUUID(uuid:any) {
         const url = `${baseURL}/iban/${uuid}`;

         return axios.get(url);
    }
    static getUUIDfromIBAN(iban: any, national_id: any) {
        const url = `${baseURL}/register/iban`;
      
        return axios.post(url,iban,national_id);
    }
   static async uploadAttachment(file: File, fieldName: string) {
        const url = `${baseURL}/register/upload-attachment`;
        const payload={
            file: file,
            field_name: fieldName
        }
        return axios.post(url, payload);
    }
}

export default CharityRegisterService;
